import { CSSProperties } from 'react';
import './index.less';

export const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  className = '',
  style = {}
}: {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (arg: boolean) => void;
  className?: string;
  style?: CSSProperties;
}) => {
  const handleChange = () => {
    if (!disabled) {
      if (onChange) {
        onChange(!checked);
      }
    }
  };

  return (
    <div
      className={`custom-switch ${className}  ${disabled ? 'disabled' : ''}`}
      style={style}
    >
      <div
        className={`switch ${checked ? 'switch__checked' : ''}`}
        onClick={handleChange}
      >
        <div className="slider"></div>
      </div>
    </div>
  );
};
